<template lang="pug">
  .person-search
    PersonSearchForm(v-if="!searched",@personSearch="search")
</template>

<script>
import PersonSearchForm from '../components/PersonSearchForm'
import * as personService from '../lib/services/personSearch'
import { globalError } from '@/lib/utils'

export default {
  name: 'PersonSearch',
  data: function() {
    return {
      searched: false,
      searchResults: [],
      searchData: {},
    }
  },
  methods: {
    search: async function(searchData) {
      try {
        this.$store.commit('incLoader')
        let resp = await personService.search(searchData)
        this.$router.push({
          name: 'search_results',
          query: { id: resp.data.id },
        })
      } catch (err) {
        this.$store.commit('resetLoader')
        globalError(err)
      }
    },
  },
  mounted() {
    scrollTo(0, 0)
  },
  components: {
    PersonSearchForm,
  },
}
</script>

<style lang="scss" scoped>
</style>
